(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
  window.SblaIngV1 = window.SblaIngV1 || {};
  window.SblaIngV1.init = function(sectionId) {
    var root = document.querySelector('[data-sbla-ing-v1-id="' + sectionId + '"]');
    if (!root) return;
    root.querySelectorAll('[data-sbla-ing-v1-card]').forEach(function(card) {
      var toggle = card.querySelector('.sbla-ing-v1-toggle');
      card.setAttribute('tabindex', '0');
      card.setAttribute('role', 'button');
      card.setAttribute('aria-expanded', 'false');
      function toggleCard() {
        var isOpen = card.classList.toggle('sbla-ing-v1-is-open');
        card.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if (toggle) toggle.textContent = isOpen ? 'Show less \u25b4' : 'Learn more \u25be';
      }
      card.addEventListener('click', toggleCard);
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleCard(); }
      });
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-above-fold-v4"] && !Shopify.designMode) return;
  try {
    
  window.SblaPdpV4 = window.SblaPdpV4 || {};
  window.SblaPdpV4.init = function(sectionId) {
    var root = document.querySelector('[data-sbla-pdp-v4-id="' + sectionId + '"]');
    if (!root || root.hasAttribute('data-sbla-pdp-v4-ready')) return;
    root.setAttribute('data-sbla-pdp-v4-ready', '1');

    var slides     = Array.from(root.querySelectorAll('[data-sbla-pdp-v4-slide]'));
    var thumbs     = Array.from(root.querySelectorAll('[data-sbla-pdp-v4-thumb]'));
    var dots       = Array.from(root.querySelectorAll('[data-sbla-pdp-v4-dot]'));
    var actionBtns = Array.from(root.querySelectorAll('[data-sbla-pdp-v4-target]'));
    var prevBtn    = root.querySelector('[data-sbla-pdp-v4-prev]');
    var nextBtn    = root.querySelector('[data-sbla-pdp-v4-next]');
    var stage      = root.querySelector('[data-sbla-pdp-v4-stage]');
    var TOTAL      = slides.length;
    var current    = 0;
    var touchStartX = 0;
    var ACTIVE = 'sbla-pdp-v4-active';

    if (TOTAL > 0) {
      function goTo(idx) {
        idx = ((idx % TOTAL) + TOTAL) % TOTAL;
        slides[current].classList.remove(ACTIVE);
        if (thumbs[current])  thumbs[current].classList.remove(ACTIVE);
        if (dots[current]) {
          dots[current].classList.remove(ACTIVE);
          dots[current].setAttribute('aria-selected', 'false');
        }
        current = idx;
        slides[current].classList.add(ACTIVE);
        if (thumbs[current])  thumbs[current].classList.add(ACTIVE);
        if (dots[current]) {
          dots[current].classList.add(ACTIVE);
          dots[current].setAttribute('aria-selected', 'true');
        }
        actionBtns.forEach(function(btn) {
          btn.classList.toggle(ACTIVE, parseInt(btn.dataset.sblaPdpV4Target) === current);
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });
      thumbs.forEach(function(t) {
        t.addEventListener('click', function() { goTo(parseInt(t.dataset.sblaPdpV4Thumb)); });
      });
      dots.forEach(function(d) {
        d.addEventListener('click', function() { goTo(parseInt(d.dataset.sblaPdpV4Dot)); });
      });
      actionBtns.forEach(function(b) {
        b.addEventListener('click', function() { goTo(parseInt(b.dataset.sblaPdpV4Target)); });
      });

      if (stage) {
        stage.addEventListener('keydown', function(e) {
          if (e.key === 'ArrowLeft')  goTo(current - 1);
          if (e.key === 'ArrowRight') goTo(current + 1);
        });
        stage.addEventListener('touchstart', function(e) {
          touchStartX = e.touches[0].clientX;
        }, { passive: true });
        stage.addEventListener('touchend', function(e) {
          var dx = e.changedTouches[0].clientX - touchStartX;
          if (Math.abs(dx) > 40) goTo(current + (dx < 0 ? 1 : -1));
        });
      }
    }

    var qtyRow = root.querySelector('.sbla-pdp-v4-qty-row');
    if (qtyRow) {
      var qtyInput = qtyRow.querySelector('.sbla-pdp-v4-qty-input');
      var qtyMinus = qtyRow.querySelector('[data-sbla-pdp-v4-minus]');
      var qtyPlus  = qtyRow.querySelector('[data-sbla-pdp-v4-plus]');
      if (qtyInput) {
        if (qtyMinus) qtyMinus.addEventListener('click', function() {
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value) || 1) - 1);
        });
        if (qtyPlus) qtyPlus.addEventListener('click', function() {
          qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
        });
      }
    }
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbla-clinical-results"] && !Shopify.designMode) return;
  try {
    
  window.SblaCr = window.SblaCr || {};
  window.SblaCr.init = function (root) {
    if (!root || root.__sblaCrBound) return;
    root.__sblaCrBound = true;

    var rail = root.querySelector('[data-sbla-cr-rail]');
    var nav = root.querySelector('[data-sbla-cr-nav]');
    if (!rail || !nav) return;
    var prev = nav.querySelector('[data-sbla-cr-prev]');
    var next = nav.querySelector('[data-sbla-cr-next]');
    var prog = root.querySelector('[data-sbla-cr-progress]');
    var bar = prog && prog.firstElementChild;

    function step() {
      var first = rail.firstElementChild;
      if (!first) return rail.clientWidth;
      var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    // The buttons only exist when the rail actually overflows: two
    // permanently disabled circles are furniture, not navigation.
    function sync() {
      var over = rail.scrollWidth > rail.clientWidth + 2;
      nav.hidden = !over;
      if (prog) prog.hidden = !over;
      if (!over) return;
      var max = rail.scrollWidth - rail.clientWidth;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max - 2;
      // Share of the row on screen, and how far along it is. Percentages of
      // the bar's own width, so the maths holds at any subject count.
      if (bar) {
        bar.style.width = (rail.clientWidth / rail.scrollWidth * 100) + '%';
        bar.style.left = (rail.scrollLeft / rail.scrollWidth * 100) + '%';
      }
    }

    if (prev) prev.addEventListener('click', function () { rail.scrollLeft -= step(); });
    if (next) next.addEventListener('click', function () { rail.scrollLeft += step(); });
    rail.addEventListener('scroll', sync, { passive: true });
    if (typeof ResizeObserver === 'function') new ResizeObserver(sync).observe(rail);
    else window.addEventListener('resize', sync);
    sync();
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbla-compare"] && !Shopify.designMode) return;
  try {
    
  window.SblaCmp = window.SblaCmp || {};
  window.SblaCmp.init = function (sectionId) {
    var root = document.querySelector('[data-sbla-cmp-id="' + sectionId + '"]');
    if (!root || root.hasAttribute('data-sbla-cmp-ready')) return;
    root.setAttribute('data-sbla-cmp-ready', '1');
    var page = root.getAttribute('data-sbla-cmp-page') || '';

    // Analytics: one event each for seen, scrolled sideways and CTA clicked.
    // Goes to the dataLayer when there is one, and always as a DOM event.
    var sent = {};
    var track = function (name) {
      if (sent[name]) return;
      sent[name] = true;
      var detail = { event: name, page: page, section: sectionId };
      if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(detail);
      root.dispatchEvent(new CustomEvent('sbla:compare', { bubbles: true, detail: detail }));
    };
    if ('IntersectionObserver' in window) {
      // "Seen": half the table on screen, or half the screen filled by it
      // (on a phone a long table is taller than two screens).
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var half = Math.min(en.boundingClientRect.height, window.innerHeight) * 0.5;
          if (en.isIntersecting && en.intersectionRect.height >= half) { track('sbla_compare_view'); io.disconnect(); }
        });
      }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5] });
      io.observe(root.querySelector('.sbla-cmp-table') || root);
    }
    var sc = root.querySelector('[data-sbla-cmp-scroll]');
    if (sc) sc.addEventListener('scroll', function () { if (sc.scrollLeft > 24) track('sbla_compare_scroll'); }, { passive: true });

    // The CTA scrolls to the buy box; it never adds to cart.
    Array.prototype.forEach.call(root.querySelectorAll('[data-sbla-cmp-cta]'), function (a) {
      a.addEventListener('click', function (e) {
        track('sbla_compare_cta');
        var t = document.querySelector(a.getAttribute('data-sbla-cmp-cta') || '');
        if (!t) return;
        e.preventDefault();
        var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        t.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
      });
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbla-elw-faq"] && !Shopify.designMode) return;
  try {
    
  window.SblaElwFaq = window.SblaElwFaq || {};
  window.SblaElwFaq.init = function (root) {
    if (!root || root.__sblaElwFaqBound) return;
    root.__sblaElwFaqBound = true;
    if (root.getAttribute('data-sbla-elw-faq-exclusive') !== 'true') return;

    // Browsers with the native `name` attribute already close the siblings
    // themselves; doing it again here would fight them.
    if ('name' in document.createElement('details')) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sbla-elw-faq-item]'));
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbla-lfw-buy-box"] && !Shopify.designMode) return;
  try {
    
  window.SblaLfwBb = window.SblaLfwBb || {};
  window.SblaLfwBb.init = function(root) {
    if (!root || root.__sblaLfwBbBound) return;
    root.__sblaLfwBbBound = true;

    var slides     = Array.from(root.querySelectorAll('[data-sbla-lfw-bb-slide]'));
    var thumbs     = Array.from(root.querySelectorAll('[data-sbla-lfw-bb-thumb]'));
    var dots       = Array.from(root.querySelectorAll('[data-sbla-lfw-bb-dot]'));
    var actionBtns = Array.from(root.querySelectorAll('[data-sbla-lfw-bb-target]'));
    var prevBtn    = root.querySelector('[data-sbla-lfw-bb-prev]');
    var nextBtn    = root.querySelector('[data-sbla-lfw-bb-next]');
    var stage      = root.querySelector('[data-sbla-lfw-bb-stage]');
    var TOTAL      = slides.length;
    var current    = 0;
    var touchStartX = 0;
    var ACTIVE = 'sbla-lfw-bb-active';

    if (TOTAL > 0) {
      function goTo(idx) {
        idx = ((idx % TOTAL) + TOTAL) % TOTAL;
        slides[current].classList.remove(ACTIVE);
        if (thumbs[current])  thumbs[current].classList.remove(ACTIVE);
        if (dots[current]) {
          dots[current].classList.remove(ACTIVE);
          dots[current].removeAttribute('aria-current');
        }
        current = idx;
        slides[current].classList.add(ACTIVE);
        if (thumbs[current])  thumbs[current].classList.add(ACTIVE);
        if (dots[current]) {
          dots[current].classList.add(ACTIVE);
          dots[current].setAttribute('aria-current', 'true');
        }
        actionBtns.forEach(function(btn) {
          var on = parseInt(btn.dataset.sblaLfwBbTarget) === current;
          btn.classList.toggle(ACTIVE, on);
          // The gallery tabs carry aria-pressed; keep it on the slide shown.
          if (btn.hasAttribute('aria-pressed')) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });
      thumbs.forEach(function(t) {
        t.addEventListener('click', function() { goTo(parseInt(t.dataset.sblaLfwBbThumb)); });
      });
      dots.forEach(function(d) {
        d.addEventListener('click', function() { goTo(parseInt(d.dataset.sblaLfwBbDot)); });
      });
      actionBtns.forEach(function(b) {
        b.addEventListener('click', function() { goTo(parseInt(b.dataset.sblaLfwBbTarget)); });
      });

      if (stage) {
        stage.addEventListener('keydown', function(e) {
          if (e.key === 'ArrowLeft')  goTo(current - 1);
          if (e.key === 'ArrowRight') goTo(current + 1);
        });
        stage.addEventListener('touchstart', function(e) {
          touchStartX = e.touches[0].clientX;
        }, { passive: true });
        stage.addEventListener('touchend', function(e) {
          var dx = e.changedTouches[0].clientX - touchStartX;
          if (Math.abs(dx) > 40) goTo(current + (dx < 0 ? 1 : -1));
        });
      }
    }

    var qtyRow = root.querySelector('.sbla-lfw-bb-qty-row');
    if (qtyRow) {
      var qtyInput = qtyRow.querySelector('.sbla-lfw-bb-qty-input');
      var qtyMinus = qtyRow.querySelector('[data-sbla-lfw-bb-minus]');
      var qtyPlus  = qtyRow.querySelector('[data-sbla-lfw-bb-plus]');
      if (qtyInput) {
        if (qtyMinus) qtyMinus.addEventListener('click', function() {
          qtyInput.value = Math.max(1, (parseInt(qtyInput.value) || 1) - 1);
        });
        if (qtyPlus) qtyPlus.addEventListener('click', function() {
          qtyInput.value = (parseInt(qtyInput.value) || 1) + 1;
        });
      }
    }
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbla-lfw-complete-the-face"] && !Shopify.designMode) return;
  try {
    
  window.SblaLfwCtf = window.SblaLfwCtf || {};
  window.SblaLfwCtf.init = function (root) {
    if (!root || root.__sblaLfwCtfBound) return;
    root.__sblaLfwCtfBound = true;

    // ── The row ── controls only while it overflows, never by screen size.
    (function () {
      var row = root.querySelector('[data-sbla-lfw-ctf-list]');
      var ctl = root.querySelector('[data-sbla-lfw-ctf-ctl]');
      if (!row || !ctl) return;
      var prev = ctl.querySelector('[data-sbla-lfw-ctf-prev]');
      var next = ctl.querySelector('[data-sbla-lfw-ctf-next]');
      var bar = ctl.querySelector('.sbla-lfw-ctf-progress span');
      var step = function () {
        var first = row.firstElementChild;
        if (!first) return row.clientWidth;
        return first.getBoundingClientRect().width + (parseFloat(getComputedStyle(row).columnGap) || 0);
      };
      var sync = function () {
        var over = row.scrollWidth > row.clientWidth + 2;
        ctl.hidden = !over;
        if (!over) return;
        var max = row.scrollWidth - row.clientWidth;
        if (prev) prev.disabled = row.scrollLeft <= 2;
        if (next) next.disabled = row.scrollLeft >= max - 2;
        if (bar) {
          bar.style.width = (row.clientWidth / row.scrollWidth * 100) + '%';
          bar.style.left = (row.scrollLeft / row.scrollWidth * 100) + '%';
        }
      };
      if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { row.scrollBy({ left: step(), behavior: 'smooth' }); });
      row.addEventListener('scroll', sync, { passive: true });
      if (typeof ResizeObserver === 'function') new ResizeObserver(sync).observe(row);
      else window.addEventListener('resize', sync);
      sync();
    })();

    // Progressive enhancement only. Without it (or without fetch) the form
    // posts to /cart/add the standard way.
    if (root.getAttribute('data-sbla-lfw-ctf-ajax') !== 'true') return;
    if (typeof fetch !== 'function' || typeof FormData !== 'function') return;

    var addedLabel = root.getAttribute('data-sbla-lfw-ctf-added') || '';
    var status = root.querySelector('[data-sbla-lfw-ctf-status]');
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    Array.prototype.forEach.call(root.querySelectorAll('[data-sbla-lfw-ctf-card] form'), function (form) {
      var card = form.closest('[data-sbla-lfw-ctf-card]');
      var btn = form.querySelector('[data-sbla-lfw-ctf-add]');
      var txt = form.querySelector('[data-sbla-lfw-ctf-add-text]');
      if (!btn || !txt) return;
      var idle = txt.textContent;
      var timer = null;

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (btn.getAttribute('aria-busy') === 'true') return;
        btn.setAttribute('aria-busy', 'true');

        fetch(base + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) {
            if (!r.ok) throw new Error('cart/add.js ' + r.status);
            return r.json();
          })
          .then(function (item) {
            btn.removeAttribute('aria-busy');
            if (addedLabel) {
              txt.textContent = addedLabel;
              if (status) status.textContent = addedLabel + ': ' + (card ? card.getAttribute('data-sbla-lfw-ctf-title') : '');
            }
            btn.setAttribute('data-sbla-lfw-ctf-state', 'added');
            clearTimeout(timer);
            timer = setTimeout(function () {
              txt.textContent = idle;
              btn.removeAttribute('data-sbla-lfw-ctf-state');
              if (status) status.textContent = '';
            }, 2000);
            var detail = { source: 'sbla-lfw-ctf', item: item };
            try {
              document.dispatchEvent(new CustomEvent('sbla-lfw-ctf:added', { bubbles: true, detail: detail }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
            } catch (err) {}
          })
          .catch(function () {
            // Anything wrong (network, sold out, a theme that answers
            // differently): hand the form to the browser. submit() does not
            // fire this listener again.
            btn.removeAttribute('aria-busy');
            form.submit();
          });
      });
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbla-lfw-faq"] && !Shopify.designMode) return;
  try {
    
  window.SblaLfwFaq = window.SblaLfwFaq || {};
  window.SblaLfwFaq.init = function (root) {
    if (!root || root.__sblaLfwFaqBound) return;
    root.__sblaLfwFaqBound = true;
    if (root.getAttribute('data-sbla-lfw-faq-exclusive') !== 'true') return;

    // Browsers with the native `name` attribute already close the siblings
    // themselves; doing it again here would fight them.
    if ('name' in document.createElement('details')) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sbla-lfw-faq-item]'));
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbla-lfw-hero"] && !Shopify.designMode) return;
  try {
    
  window.SblaLfwHero = window.SblaLfwHero || {};
  window.SblaLfwHero.init = function (root) {
    if (!root || root.__sblaLfwHeroBound) return;
    root.__sblaLfwHeroBound = true;
    var cue = root.querySelector('[data-sbla-lfw-hero-cue]');
    if (!cue) return;
    var sel = (root.getAttribute('data-sbla-lfw-hero-cue-target') || '').trim();
    var offset = parseInt(root.getAttribute('data-sbla-lfw-hero-cue-offset'), 10) || 0;
    cue.addEventListener('click', function () {
      var el = null;
      try { el = sel ? document.querySelector(sel) : null; } catch (e) {}
      // Fall back to the next section, so the hook always goes somewhere.
      if (!el) { var w = root.closest('.shopify-section') || root; el = w.nextElementSibling; }
      if (!el) return;
      var y = el.getBoundingClientRect().top + window.pageYOffset - offset;
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: y < 0 ? 0 : y, behavior: still ? 'auto' : 'smooth' });
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbla-lfw-results"] && !Shopify.designMode) return;
  try {
    
  window.SblaLfwRes = window.SblaLfwRes || {};
  window.SblaLfwRes.init = function (root) {
    if (!root || root.__sblaLfwResBound) return;
    root.__sblaLfwResBound = true;

    // ── Rails ──
    // One behaviour for the photograph rail and the application strip. The
    // controls exist only while the row overflows: two permanently disabled
    // circles are furniture, not navigation. Never hidden by screen size,
    // since a narrow window is not the same thing as a touchscreen.
    var wire = function (row, ctl, prog) {
      if (!row || !ctl) return;
      var prev = ctl.querySelector('[data-sbla-lfw-res-prev]');
      var next = ctl.querySelector('[data-sbla-lfw-res-next]');
      var bar = prog && prog.firstElementChild;

      var step = function () {
        var first = row.firstElementChild;
        if (!first) return row.clientWidth;
        var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      };

      var sync = function () {
        var over = row.scrollWidth > row.clientWidth + 2;
        ctl.hidden = !over;
        if (prog) prog.hidden = !over;
        if (!over) return;
        var max = row.scrollWidth - row.clientWidth;
        if (prev) prev.disabled = row.scrollLeft <= 2;
        if (next) next.disabled = row.scrollLeft >= max - 2;
        // Share of the row on screen, and how far along it is, as
        // percentages of the bar's own width: honest at any item count.
        if (bar) {
          bar.style.width = (row.clientWidth / row.scrollWidth * 100) + '%';
          bar.style.left = (row.scrollLeft / row.scrollWidth * 100) + '%';
        }
      };

      if (prev) prev.addEventListener('click', function () { row.scrollLeft -= step(); });
      if (next) next.addEventListener('click', function () { row.scrollLeft += step(); });
      row.addEventListener('scroll', sync, { passive: true });
      if (typeof ResizeObserver === 'function') new ResizeObserver(sync).observe(row);
      else window.addEventListener('resize', sync);
      // Photographs without declared dimensions change the row's width as
      // they arrive.
      Array.prototype.forEach.call(row.querySelectorAll('img'), function (img) {
        if (!img.complete) img.addEventListener('load', sync);
      });
      sync();
    };

    wire(root.querySelector('[data-sbla-lfw-res-rail]'), root.querySelector('[data-sbla-lfw-res-nav]'), root.querySelector('[data-sbla-lfw-res-progress]'));
    var stripCtl = root.querySelector('[data-sbla-lfw-res-strip-ctl]');
    wire(root.querySelector('[data-sbla-lfw-res-strip]'), stripCtl, stripCtl && stripCtl.querySelector('.sbla-lfw-res-progress'));

    // ── Link to the buy box ──
    Array.prototype.forEach.call(root.querySelectorAll('[data-sbla-lfw-res-cta]'), function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector(a.getAttribute('data-sbla-lfw-res-cta') || '');
        if (!t) return;
        e.preventDefault();
        var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        t.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
      });
    });

    // ── Video poster ──
    // A video tile with no uploaded poster starts hidden and is shown only once
    // a sharp still has loaded, so Wistia's blurred swatch never appears. The
    // still comes from Wistia's oEmbed; if that is refused (CORS, ad blockers),
    // from the media's JSONP data, which is how Wistia's own embed reads it.
    Array.prototype.forEach.call(root.querySelectorAll('[data-sbla-lfw-res-autoposter]'), function (tile) {
      var id = tile.getAttribute('data-sbla-lfw-res-autoposter') || '';
      var img = tile.querySelector('[data-sbla-lfw-res-poster]');
      if (!/^[A-Za-z0-9]+$/.test(id) || !img) return;
      var done = false;
      var show = function (u) {
        if (done || !u || !/^https:\/\//.test(u)) return;
        done = true;
        img.addEventListener('load', function () {
          tile.hidden = false;
          // The strip may now overflow: let its controls re-measure.
          try { window.dispatchEvent(new Event('resize')); } catch (e) {}
        });
        // A lazy image inside a hidden tile would never load.
        img.loading = 'eager';
        img.src = u.split('?')[0].replace(/\.bin$/, '.jpg') + '?image_crop_resized=1280x720';
      };
      var jsonp = function () {
        if (done) return;
        var key = 'wistiajsonp-/embed/medias/' + id + '.jsonp';
        var sc = document.createElement('script');
        sc.async = true;
        sc.src = 'https://fast.wistia.com/embed/medias/' + id + '.jsonp';
        sc.onload = function () {
          var d = window[key], a = (d && d.media && d.media.assets) || [];
          for (var i = 0; i < a.length; i++) if (a[i].type === 'still_image' && a[i].url) return show(a[i].url);
        };
        document.head.appendChild(sc);
      };
      if (!window.fetch) return jsonp();
      fetch('https://fast.wistia.com/oembed?url=' + encodeURIComponent('https://home.wistia.com/medias/' + id))
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d && d.thumbnail_url) show(d.thumbnail_url); else jsonp(); })
        .catch(jsonp);
    });

    // ── Wistia facade ──
    // Nothing from Wistia loads until play is pressed; then the iframe
    // takes the poster's place at the tile's size.
    Array.prototype.forEach.call(root.querySelectorAll('[data-sbla-lfw-res-play]'), function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-sbla-lfw-res-wistia') || '';
        if (!/^[A-Za-z0-9]+$/.test(id)) return;
        var media = btn.closest('[data-sbla-lfw-res-media]');
        if (!media) return;
        var frame = document.createElement('iframe');
        frame.className = 'sbla-lfw-res-frame';
        frame.src = 'https://fast.wistia.net/embed/iframe/' + id + '?autoPlay=true&playsinline=true';
        frame.setAttribute('allow', 'autoplay; fullscreen');
        frame.setAttribute('allowfullscreen', '');
        frame.title = btn.getAttribute('data-sbla-lfw-res-title') || btn.getAttribute('aria-label') || '';
        while (media.firstChild) media.removeChild(media.firstChild);
        media.appendChild(frame);
        // The button that had focus is gone; keep keyboard users in place.
        try { frame.focus(); } catch (e) {}
      });
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbla-lfw-zone-map"] && !Shopify.designMode) return;
  try {
    
  window.SblaLfwZm = window.SblaLfwZm || {};
  window.SblaLfwZm.init = function (root) {
    if (!root || root.__sblaLfwZmBound) return;
    root.__sblaLfwZmBound = true;

    var ACTIVE = 'sbla-lfw-zm-active';
    var dots = Array.prototype.slice.call(root.querySelectorAll('.sbla-lfw-zm-dot[data-sbla-lfw-zm-zone]'));
    var items = Array.prototype.slice.call(root.querySelectorAll('.sbla-lfw-zm-item[data-sbla-lfw-zm-zone]'));
    if (!dots.length || !items.length) return;

    var desk = window.matchMedia ? window.matchMedia('(min-width: 769px)') : null;
    var pinned = null;   // set by a click; aria-pressed reports it
    var hovered = null;  // hover or focus, wins while it lasts

    function zoneOf(el) { return el.getAttribute('data-sbla-lfw-zm-zone'); }

    function paint() {
      var on = hovered !== null ? hovered : pinned;
      dots.forEach(function (d) {
        var z = zoneOf(d);
        d.classList.toggle(ACTIVE, z === on);
        d.setAttribute('aria-pressed', z === pinned ? 'true' : 'false');
      });
      items.forEach(function (li) { li.classList.toggle(ACTIVE, zoneOf(li) === on); });
    }

    function enter(el) { return function () { hovered = zoneOf(el); paint(); }; }
    function leave(el) {
      return function () { if (hovered === zoneOf(el)) { hovered = null; paint(); } };
    }
    function pin(el) {
      return function () {
        if (desk && !desk.matches) return;
        var z = zoneOf(el);
        pinned = pinned === z ? null : z;
        paint();
      };
    }

    dots.concat(items).forEach(function (el) {
      el.addEventListener('mouseenter', enter(el));
      el.addEventListener('mouseleave', leave(el));
      el.addEventListener('focus', enter(el));
      el.addEventListener('blur', leave(el));
      el.addEventListener('click', pin(el));
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pinned !== null) { pinned = null; paint(); }
    });

    // The list lines take keyboard focus on desktop only. On a phone they
    // do nothing, so they stay out of the tab order.
    function sync() {
      var on = !desk || desk.matches;
      items.forEach(function (li) {
        if (on) li.setAttribute('tabindex', '0');
        else li.removeAttribute('tabindex');
      });
      if (!on) { pinned = null; hovered = null; paint(); }
    }
    if (desk) {
      if (desk.addEventListener) desk.addEventListener('change', sync);
      else if (desk.addListener) desk.addListener(sync);
    }
    sync();
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbla-presell-hero"] && !Shopify.designMode) return;
  try {
    
  window.SblaPh = window.SblaPh || {};
  window.SblaPh.init = function (root) {
    if (!root || root.__sblaPhBound) return;
    root.__sblaPhBound = true;
    var cue = root.querySelector('[data-sbla-ph-cue]');
    if (!cue) return;
    var sel = (root.getAttribute('data-sbla-ph-cue-target') || '').trim();
    var offset = parseInt(root.getAttribute('data-sbla-ph-cue-offset'), 10) || 0;
    cue.addEventListener('click', function () {
      var el = null;
      try { el = sel ? document.querySelector(sel) : null; } catch (e) {}
      // Fall back to the next section, so the hook always goes somewhere.
      if (!el) { var w = root.closest('.shopify-section') || root; el = w.nextElementSibling; }
      if (!el) return;
      var y = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbla-reasons-accordion"] && !Shopify.designMode) return;
  try {
    
  window.SblaRz = window.SblaRz || {};
  window.SblaRz.init = function (root) {
    if (!root || root.__sblaRzBound) return;
    root.__sblaRzBound = true;
    if (root.getAttribute('data-sbla-rz-exclusive') !== 'true') return;

    // Browsers with the native `name` attribute already close the siblings
    // themselves; doing it again here would fight them.
    if ('name' in document.createElement('details')) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sbla-rz-item]'));
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  };

  } catch(e) { console.error(e); }
})();
})();
